import { render, staticRenderFns } from "./CardColumnGroups.vue?vue&type=template&id=0f7fb43c"
import script from "./CardColumnGroups.vue?vue&type=script&lang=js"
export * from "./CardColumnGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports